import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark-800 border-t border-gold-900/30 pt-16 pb-8" data-id="element-33">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-35">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-1" data-id="element-36">
            <div className="flex items-center space-x-3 mb-6" data-id="element-37">
              <img src="https://cdn.magicpatterns.com/uploads/ue8vBFZwEq6iFGtuLhrkM6/Podcastlogo3doves.jpg" alt="3 Doves Podcast" className="h-12 w-12 rounded-full border border-gold-500/30" data-id="element-38" />
              <span className="text-xl font-serif font-bold text-gold-400" data-id="element-39">
                3 Doves
              </span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6" data-id="element-40">
              Honest faith. Real stories. Lives transformed. Join us as we
              explore what it means to walk with God in everyday life.
            </p>
            <div className="flex space-x-4" data-id="element-41">
              <a href="#" className="text-white/50 hover:text-gold-400 transition-colors" data-id="element-42">
                <Facebook size={20} data-id="element-43" />
              </a>
              <a href="#" className="text-white/50 hover:text-gold-400 transition-colors" data-id="element-44">
                <Instagram size={20} data-id="element-45" />
              </a>
              <a href="#" className="text-white/50 hover:text-gold-400 transition-colors" data-id="element-46">
                <Youtube size={20} data-id="element-47" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-48">
            <h3 className="text-gold-500 font-serif font-semibold mb-6" data-id="element-49">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-50">
              <li data-id="element-51">
                <Link to="/about" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-52">
                  About Jason
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/podcasts" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-54">
                  All Episodes
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/guests" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-56">
                  Meet Guests
                </Link>
              </li>
              <li data-id="element-57">
                <Link to="/bookstore" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-58">
                  Bookstore
                </Link>
              </li>
            </ul>
          </div>

          {/* Mission */}
          <div data-id="element-59">
            <h3 className="text-gold-500 font-serif font-semibold mb-6" data-id="element-60">
              Get Involved
            </h3>
            <ul className="space-y-3" data-id="element-61">
              <li data-id="element-62">
                <Link to="/outreach" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-63">
                  Operation Olive Branch
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/share" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-65">
                  Share
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/contact" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-67">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Listen Now */}
          <div data-id="element-68">
            <h3 className="text-gold-500 font-serif font-semibold mb-6" data-id="element-69">
              Listen Now
            </h3>
            <div className="space-y-3" data-id="element-70">
              <a href="https://open.spotify.com/show/5nWVRvG1GtlfUXUfN77LfL?uid=6311ed14474123bc694c&uri=spotify:episode:4Jci4PYyVQ7HoRSNHKKRBt" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 p-3 bg-dark-700 rounded-lg hover:bg-dark-600 transition-colors group border border-dark-600 hover:border-gold-500/30" data-id="element-71">
                <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center text-black font-bold text-xs" data-id="element-72">
                  SP
                </div>
                <span className="text-sm text-white/70 group-hover:text-white" data-id="element-73">
                  Spotify
                </span>
              </a>
              <a href="https://podcasts.apple.com/us/podcast/3-doves-podcast/id1871795398" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 p-3 bg-dark-700 rounded-lg hover:bg-dark-600 transition-colors group border border-dark-600 hover:border-gold-500/30" data-id="element-74">
                <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-black font-bold text-xs" data-id="element-75">
                  AP
                </div>
                <span className="text-sm text-white/70 group-hover:text-white" data-id="element-76">
                  Apple Podcasts
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-dark-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-77">
          <p className="text-white/50 text-sm text-center md:text-left" data-id="element-78">
            &copy; {new Date().getFullYear()} 3 Doves Podcast. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-79">
            <Link to="/privacy-policy" className="text-white/50 hover:text-gold-400 text-xs transition-colors" data-id="element-80">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-white/50 hover:text-gold-400 text-xs transition-colors" data-id="element-81">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}